import { Credentials } from '@/commons/types'

export default class UserCredentials implements Credentials {
    firstName = ''
    lastName = ''
    personCode = ''
    token = ''
}
